<template>
  <div class="phase-groups-table">
    <div class="table-toolbar">
      <el-button type="primary" size="small" round icon="el-icon-plus" @click="addRow">
        添加保障小组
      </el-button>
    </div>
    <el-table
      :data="rows"
      border
      stripe
      size="small"
      class="proto-table"
      :empty-text="emptyText"
    >
      <el-table-column type="index" label="顺序" width="56" align="center" :index="indexMethod" />
      <el-table-column label="小组名称" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.groupName" size="small" placeholder="小组名称" maxlength="100" />
        </template>
      </el-table-column>
      <el-table-column label="组长" min-width="130">
        <template slot-scope="{ row }">
          <el-select
            v-model="row.groupLeaderId"
            size="small"
            filterable
            clearable
            placeholder="选择组长"
            style="width:100%"
            @change="onLeaderChange(row)"
          >
            <el-option
              v-for="u in userOptions"
              :key="u.id"
              :label="u.name"
              :value="u.id"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="组员" min-width="160">
        <template slot-scope="{ row }">
          <el-select
            v-model="row._memberIds"
            size="small"
            multiple
            filterable
            collapse-tags
            placeholder="选择组员"
            style="width:100%"
            @change="onMembersChange(row)"
          >
            <el-option
              v-for="u in userOptions"
              :key="'m-' + u.id"
              :label="u.name"
              :value="u.id"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="工作范围" min-width="180">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.groupDuties"
            type="textarea"
            :rows="2"
            size="small"
            placeholder="职责与工作范围"
            maxlength="500"
          />
        </template>
      </el-table-column>
      <el-table-column label="超时(分钟)" width="100" align="center">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.timeoutMinutes"
            size="small"
            placeholder="—"
            maxlength="6"
            @input="onTimeoutInput(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="88" align="center" fixed="right">
        <template slot-scope="{ $index }">
          <el-button type="text" size="small" class="btn-del" @click="removeRow($index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'PhaseGroupsTable',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    userOptions: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: '暂无小组，请点击添加'
    }
  },
  computed: {
    rows: {
      get () {
        return this.value || []
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    indexMethod (index) {
      return index + 1
    },
    emptyRow () {
      return {
        groupName: '',
        groupLeaderId: undefined,
        groupLeaderName: '',
        _memberIds: [],
        groupMemberIds: '',
        groupMemberNames: '',
        groupDuties: '',
        timeoutMinutes: undefined
      }
    },
    addRow () {
      const next = [...this.rows, this.emptyRow()]
      this.$emit('input', next)
    },
    removeRow (index) {
      const next = this.rows.filter((_, i) => i !== index)
      this.$emit('input', next)
    },
    onLeaderChange (row) {
      const u = this.userOptions.find(x => x.id === row.groupLeaderId)
      row.groupLeaderName = u ? u.name : ''
    },
    onMembersChange (row) {
      const ids = row._memberIds || []
      row.groupMemberIds = ids.length ? ids.join(',') : ''
      const names = ids
        .map(id => {
          const u = this.userOptions.find(x => x.id === id)
          return u ? u.name : ''
        })
        .filter(Boolean)
      row.groupMemberNames = names.join('、')
    },
    onTimeoutInput (row) {
      if (row.timeoutMinutes === '' || row.timeoutMinutes === undefined) return
      const n = String(row.timeoutMinutes).replace(/\D/g, '')
      row.timeoutMinutes = n === '' ? undefined : n
    }
  }
}
</script>

<style scoped lang="scss">
.phase-groups-table {
  margin-top: 4px;
}
.table-toolbar {
  margin-bottom: 10px;
}
.proto-table {
  width: 100%;
  font-size: 13px;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .proto-table th {
  background: #f8fafc !important;
  color: #334155;
  font-weight: 600;
}
::v-deep .proto-table .el-table__empty-text {
  color: #94a3b8;
  padding: 20px 0;
}
.btn-del {
  color: #ef4444;
}
</style>
